module.exports = __webpack_public_path__ + "img/mens-center-of-back-traditional-sailing-ship-with-rose-flower-tattoo-design.jpg";